// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AccountAppsUpdateSchema = z.object({
  options: z.object({
    sync_all: z.boolean(),
    project_source: z.optional(z.coerce.string()),
    client_source: z.optional(z.coerce.string()),
    parent_source: z.optional(z.coerce.string()),
  }),
});
